<h1 mat-dialog-title>Building permit information</h1>
<div mat-dialog-content>

  <form [formGroup]="formPermitInfo"
    [ngStyle]="{'width': '70%'}" ngStyle.lt-lg="{'width': '100%'}">
      <mat-form-field
        appearance="outline"
        style="min-width: 250px;">
        <mat-label>Permit Issuer</mat-label>
        <input matInput autocomplete="off" readonly focus=false
          maxLength="50"
          id="permitIssuer"
          name="permitIssuer"
          formControlName="permitIssuer">
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        style="min-width: 250px;">
        <mat-label>Permit Issued Date</mat-label>
        <input matInput autocomplete="off" readonly focus=false
          maxLength="50"
          id="permitIssuedDate"
          name="permitIssuedDate"
          formControlName="permitIssuedDate">
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        style="min-width: 250px;">
        <mat-label>Permit Plan Type</mat-label>
        <input matInput autocomplete="off" readonly focus=false
          maxLength="50"
          id="permitPlanType"
          name="permitPlanType"
          formControlName="permitPlanType">
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        style="min-width: 250px;">
        <mat-label>Permit Number</mat-label>
        <input matInput autocomplete="off" readonly focus=false
          maxlength="20"
          placeholder="Permit number"
          id="permitNumber"
          name="permitNumber"
          formControlName="permitNumber">
      </mat-form-field>
  </form>

</div>
<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-raised-button
    color="primary"
    (click)="onClickClose()">
    CLOSE
  </button>
</div>